import { useMemo } from 'react';
import Select from 'react-select';

import templateLiteralToHTML from 'utils/templateLiteralToHTML';

import Error from 'components/atom/Form/ErrorMessage';
import { Label } from 'components/atom/Form/Input/styles';

import InputTooltip from '../Input/InputTooltip';
import { getValueFromOptions, getValueFromGroupedOptions } from './functions';
import { Container } from './styles';
import { ISelectType } from './types';

const MySelect: React.FC<ISelectType> = ({
  id,
  name,
  value,
  options,
  groupedOptions,
  placeholder = 'Selecione',
  onChange,
  color,
  canSearch = true,
  label,
  error,
  menuPlacement = 'auto',
  isDisabled = false,
  isRequired = false,
  tooltip,
  isHTMLLabel = false,
  ...rest
}) => {
  const processedValue = useMemo(() => {
    if (options) return getValueFromOptions({ value, options, placeholder });
    if (groupedOptions) return getValueFromGroupedOptions({ value, groupedOptions, placeholder });
    return { label: '', value: '' };
  }, [groupedOptions, options, placeholder, value]);

  return (
    <Container color={color} error={!!error} className="custom-select-container">
      {label && (
        <Label>
          <p>{isHTMLLabel ? <>{templateLiteralToHTML(label)}</> : <>{label}</>}</p>

          {isRequired && (
            <p className="required">
              <span>*</span>
            </p>
          )}

          {tooltip && <InputTooltip label={tooltip} />}
        </Label>
      )}

      <Select
        id={id}
        name={name}
        instanceId={id}
        value={processedValue}
        options={options || groupedOptions}
        onChange={(e: any) => onChange(e.value)}
        classNamePrefix="custom-select"
        noOptionsMessage={() => 'Nada encontrado.'}
        isDisabled={isDisabled}
        isSearchable={canSearch}
        menuPlacement={menuPlacement}
        {...rest}
      />

      {error && <Error>{error}</Error>}
    </Container>
  );
};

export default MySelect;
